import React from 'react';


const OrderStatusCard = ({ icon, dueDay, noOfOrders, size, dueDate, noOfOrdersClassName, dropDown}) => {
    // Function to format due date
    // const formatDueDate = () => {
    //     const today = new Date();
    //     const tomorrow = new Date(today);
    //     tomorrow.setDate(tomorrow.getDate() + 1);
    //     const formattedDueDate = new Date(dueDate);

    //     if (formattedDueDate.toDateString() === today.toDateString()) {
    //         return 'Today';
    //     } else if (formattedDueDate.toDateString() === tomorrow.toDateString()) {
    //         return 'Tomorrow';
    //     } else {
    //         return formattedDueDate.toLocaleDateString();
    //     }
    // };

    // Function to determine the due day status
    const renderDueDayStatus = () => {
        if (dueDay === 'Tomorrow') {
            return 'Due Tomorrow';
        }else if(dueDay === 'Today'){
            return 'Due Today'
        }else if (dueDay === 'In Laundry') {
            return 'In Laundry';
        } else if (dueDay === 'Ready for Pickup') {
            return 'Ready for Pickup';
        } else {
            return 'Past Due';
        }
    };

    return (
        <section>
            <div className='order-status-card-container'>
                <div className='flex gap-4'>
                    <div>{icon}</div>
                    <p className='due-text'>{renderDueDayStatus()}</p>
                    <section>
                        {dropDown}
                    </section>
                </div>
                <div className='flex gap-20 mt-7'>
                    <div>
                        <p className={`no-of-orders ${noOfOrdersClassName}`}>{noOfOrders} <span className='orders-text'>orders</span> </p>
                    </div>
                    <p className='size mt-7 ml-7'>{size}lbs</p>
                </div>
                
            </div>
        </section>
    );
}

export default OrderStatusCard;
